/** @format */

export const HERO = {
	title_1: 'you_think_it',
	title_2: 'we_build_it',
	subtitle: 'team_of_experienced_developers',
	button_text: 'get_started',
}

export const SERVICES_SECTION_TITLE = 'our_services'
export const SERVICES = [
	{
		id: '01',
		img: (
			<svg
				width='48'
				height='48'
				viewBox='0 0 48 48'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'>
				<path
					d='M21.5998 9.59995C19.7686 9.59995 18.0598 10.1112 16.603 11.0016C16.4524 10.1961 16.178 9.41892 15.7894 8.69755C17.6165 7.68643 19.6758 7.16961 21.7639 7.19816C23.8519 7.22671 25.8963 7.79965 27.6951 8.86035C29.4939 9.92105 30.9847 11.4328 32.0203 13.2462C33.0559 15.0595 33.6003 17.1117 33.5998 19.2H39.6022C40.5566 19.2006 41.4716 19.5802 42.1462 20.2552C42.8208 20.9303 43.1998 21.8456 43.1998 22.8V37.2C43.1998 38.1547 42.8205 39.0704 42.1454 39.7455C41.4703 40.4207 40.5546 40.8 39.5998 40.8H25.1998C24.245 40.8 23.3293 40.4207 22.6542 39.7455C21.9791 39.0704 21.5998 38.1547 21.5998 37.2V31.2C19.9303 31.2021 18.2789 30.8546 16.7518 30.18C16.783 29.364 16.7998 28.5072 16.7998 27.6V27.516C18.211 28.332 19.8502 28.8 21.5998 28.8V22.8C21.5998 21.8452 21.9791 20.9295 22.6542 20.2544C23.3293 19.5792 24.245 19.2 25.1998 19.2H31.1998C31.1998 16.6539 30.1884 14.2121 28.388 12.4117C26.5877 10.6114 24.1459 9.59995 21.5998 9.59995ZM33.3598 21.6C32.8877 23.9053 31.7491 26.0213 30.0851 27.6852C28.4211 29.3492 26.3052 30.4879 23.9998 30.96V37.2C23.9998 37.5182 24.1262 37.8234 24.3513 38.0485C24.5763 38.2735 24.8815 38.4 25.1998 38.4H39.5998C39.9181 38.4 40.2233 38.2735 40.4483 38.0485C40.6734 37.8234 40.7998 37.5182 40.7998 37.2V22.8C40.7998 22.4817 40.6734 22.1765 40.4483 21.9514C40.2233 21.7264 39.9181 21.6 39.5998 21.6H33.3598ZM30.8974 21.6H25.1998C24.8815 21.6 24.5763 21.7264 24.3513 21.9514C24.1262 22.1765 23.9998 22.4817 23.9998 22.8V28.4976C25.6602 28.0674 27.1753 27.201 28.3881 25.9882C29.6009 24.7754 30.4672 23.2603 30.8974 21.6ZM10.9942 5.09995C11.1934 5.2742 11.3294 5.50941 11.3811 5.76898C11.4327 6.02855 11.3971 6.29792 11.2798 6.53515C11.2595 6.60537 11.249 6.67806 11.2486 6.75115C11.2486 6.90235 11.287 7.19035 11.6494 7.55035C11.8246 7.72555 11.959 7.85035 12.1054 7.98715C12.2254 8.09755 12.3526 8.21275 12.5134 8.37115C12.8254 8.66875 13.1542 9.01915 13.4494 9.45835C14.0614 10.3776 14.3998 11.5272 14.3998 13.2C14.3998 15.2472 13.6414 16.992 12.4582 18.0624L12.6118 18.24C13.2838 19.0656 13.675 20.136 13.9198 21.192C14.3998 23.28 14.3998 25.7904 14.3998 27.54V27.6C14.3998 34.2888 13.4902 38.0832 12.4894 40.2528C11.9854 41.3448 11.4502 42.0408 10.987 42.4776C10.7987 42.6582 10.591 42.8176 10.3678 42.9528C10.2656 43.0143 10.1589 43.068 10.0486 43.1136C10.0486 43.1136 9.7774 43.2 9.5998 43.2C9.4222 43.2 9.151 43.1136 9.151 43.1136C9.03952 43.0707 8.93259 43.0168 8.8318 42.9528C8.60857 42.8176 8.40092 42.6582 8.2126 42.4776C7.7494 42.0384 7.2142 41.3448 6.7102 40.2528C5.7094 38.0832 4.7998 34.2888 4.7998 27.6V27.54C4.7998 25.788 4.7998 23.28 5.2798 21.192C5.5246 20.136 5.9158 19.0656 6.5878 18.24C6.6358 18.18 6.6886 18.12 6.7414 18.0624C5.5582 16.992 4.7998 15.2472 4.7998 13.2C4.7998 12.4176 5.0086 11.484 5.2966 10.6224C5.5846 9.75835 5.9878 8.86555 6.4534 8.14555C7.0078 7.20955 7.7878 6.42475 8.3926 5.89675C8.72418 5.60514 9.07022 5.3304 9.4294 5.07355L9.5014 5.02555L9.523 5.00875L9.5302 5.00395L9.535 5.00155C9.75507 4.85486 10.0174 4.78497 10.2813 4.80277C10.5452 4.82056 10.7958 4.92504 10.9942 5.09995ZM9.5998 16.8C10.5286 16.7976 11.9998 15.768 11.9998 13.2C11.9998 11.8728 11.7382 11.2224 11.4502 10.7904C11.2751 10.538 11.0731 10.3055 10.8478 10.0968L10.5502 9.81835C10.3558 9.63595 10.1278 9.42475 9.9502 9.24955C9.68771 8.9898 9.46238 8.69501 9.2806 8.37355C8.97511 8.69477 8.70626 9.04894 8.479 9.42955C8.143 9.94555 7.8166 10.6536 7.5742 11.3832C7.3246 12.1272 7.1998 12.7848 7.1998 13.2C7.1998 15.7728 8.6758 16.8 9.5998 16.8ZM8.4478 19.7568C8.107 20.172 7.8238 20.8344 7.6174 21.732C7.2046 23.5272 7.1998 25.7832 7.1998 27.6C7.1998 34.1112 8.0902 37.5168 8.8894 39.2472C9.1534 39.816 9.4006 40.1952 9.5998 40.4472C9.88337 40.0768 10.1218 39.6739 10.3102 39.2472C11.1094 37.5168 11.9998 34.1112 11.9998 27.6C11.9998 25.7832 11.995 23.5272 11.5798 21.732C11.3734 20.8344 11.0902 20.172 10.7518 19.7568C10.6194 19.5774 10.4454 19.4329 10.2446 19.3359C10.0439 19.2389 9.8226 19.1923 9.5998 19.2H9.595C9.37298 19.1928 9.15254 19.2398 8.9527 19.3368C8.75285 19.4338 8.57958 19.5779 8.4478 19.7568Z'
					fill='#21D6D6'
				/>
			</svg>
		),
		title: 'UI/UX Design',
		subtitle:
			'Lorem ipsum dolor sit amet consectetur. Sem cursus cursus ultrices egestas. Sed proin laoreet id tincidunt egestas. Scelerisque enim velit elementum ac vel fames id. Commodo facilisis proin eu molestie nulla imperdiet viverra porttitor faucibus',
	},
	{
		id: '02',
		img: (
			<svg
				width='48'
				height='48'
				viewBox='0 0 48 48'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'>
				<path
					d='M39 3H45V9H39V3ZM39 12H45V18H39V12ZM30 3H36V9H30V3ZM30 12H36V18H30V12Z'
					fill='#21D6D6'
				/>
				<path
					d='M42 24V33H6V9H24V6H6C5.20435 6 4.44129 6.31607 3.87868 6.87868C3.31607 7.44129 3 8.20435 3 9V33C3 33.7956 3.31607 34.5587 3.87868 35.1213C4.44129 35.6839 5.20435 36 6 36H18V42H12V45H36V42H30V36H42C42.7957 36 43.5587 35.6839 44.1213 35.1213C44.6839 34.5587 45 33.7956 45 33V24H42ZM27 42H21V36H27V42Z'
					fill='#21D6D6'
				/>
			</svg>
		),
		title: 'Software Development',
		subtitle:
			'Lorem ipsum dolor sit amet consectetur. Sem cursus cursus ultrices egestas. Sed proin laoreet id tincidunt egestas. Scelerisque enim velit elementum ac vel fames id. Commodo facilisis proin eu molestie nulla imperdiet viverra porttitor faucibus',
	},
	{
		id: '03',
		img: (
			<svg
				width='48'
				height='48'
				viewBox='0 0 48 48'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'>
				<path
					d='M37.8362 34.9601C37.5842 40.4141 33.0682 44.3521 27.1082 44.3521H14.6802V32.1061L10.3102 30.1921V48.0001H27.0722C35.7402 48.0001 42.1702 42.0761 42.1702 34.2381V33.9121C40.8702 34.3821 39.4262 34.7421 37.8362 34.9601ZM40.5462 15.9581C37.2222 8.62614 35.4522 1.97814 30.8642 0.426137C28.1922 -0.477863 26.8542 0.244137 25.5902 0.860137C25.499 0.90351 25.4199 0.968795 25.36 1.05017C25.3001 1.13154 25.2613 1.22647 25.2471 1.32648C25.2328 1.4265 25.2435 1.52848 25.2783 1.62335C25.313 1.71821 25.3707 1.80299 25.4462 1.87014C26.1682 2.48414 27.0722 3.24414 28.1182 4.21814C24.2182 1.94214 13.4522 -1.45186 12.3702 2.66614C11.3942 6.38614 9.7322 11.8401 9.7322 11.8401C9.7322 11.8401 1.2062 10.9741 0.232203 14.5861C-0.743797 18.1981 6.8782 25.1341 19.4862 28.8541C32.0922 32.5761 41.8822 31.6001 46.1082 27.0121C50.3342 22.4241 46.2522 16.0661 40.5462 15.9581ZM38.0522 16.0301C37.0782 16.9701 33.8982 19.3901 26.9262 18.8841C19.4502 18.3421 13.3082 13.9361 11.7182 12.7081C11.5929 12.6231 11.4998 12.4983 11.4541 12.3539C11.4084 12.2094 11.4126 12.0538 11.4662 11.9121C11.5742 11.5521 11.7182 10.9741 11.9722 10.2141C12.1162 9.74614 12.6582 9.52814 13.0562 9.78214C16.1982 11.5881 21.2562 14.2241 26.6382 14.5861C31.4422 14.9121 34.3322 13.5021 36.2102 12.4541C36.3065 12.4035 36.4124 12.3736 36.521 12.3664C36.6296 12.3591 36.7385 12.3748 36.8406 12.4123C36.9428 12.4498 37.0359 12.5084 37.1141 12.5841C37.1922 12.6599 37.2536 12.7512 37.2942 12.8521L38.2342 15.1641C38.3062 15.4881 38.2702 15.8141 38.0522 16.0301Z'
					fill='#21D6D6'
				/>
			</svg>
		),
		title: 'Cyber Security',
		subtitle:
			'Lorem ipsum dolor sit amet consectetur. Sem cursus cursus ultrices egestas. Sed proin laoreet id tincidunt egestas. Scelerisque enim velit elementum ac vel fames id. Commodo facilisis proin eu molestie nulla imperdiet viverra porttitor faucibus',
	},
	{
		id: '04',
		img: (
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 40'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'>
				<path
					d='M36 27V12L23.5 4.96899M16.5 4.96899L4 12V27M7 31.688L20 39L28 34.5L33 31.688M20 14L23 15.75L26 17.5V24.5L23 26.25L20 28L17 26.25L14 24.5V17.5L17 15.75L20 14ZM20 14V6.99999M26 24L33 28M14 24L7 28'
					stroke='#21D6D6'
					strokeWidth='2'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M20 7C21.6569 7 23 5.65685 23 4C23 2.34315 21.6569 1 20 1C18.3431 1 17 2.34315 17 4C17 5.65685 18.3431 7 20 7Z'
					stroke='#21D6D6'
					strokeWidth='2'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M4 33C5.65685 33 7 31.6569 7 30C7 28.3431 5.65685 27 4 27C2.34315 27 1 28.3431 1 30C1 31.6569 2.34315 33 4 33Z'
					stroke='#21D6D6'
					strokeWidth='2'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M36 33C37.6569 33 39 31.6569 39 30C39 28.3431 37.6569 27 36 27C34.3431 27 33 28.3431 33 30C33 31.6569 34.3431 33 36 33Z'
					stroke='#21D6D6'
					strokeWidth='2'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</svg>
		),
		title: 'Blockchain Development',
		subtitle:
			'Lorem ipsum dolor sit amet consectetur. Sem cursus cursus ultrices egestas. Sed proin laoreet id tincidunt egestas. Scelerisque enim velit elementum ac vel fames id. Commodo facilisis proin eu molestie nulla imperdiet viverra porttitor faucibus',
	},
]

export const WORK_SECTION_TITLE = 'our_creative_work'
export const WORK = [
	{
		id: '01',
		title: 'Case Study Name',
		tag_1: 'Web Design',
		tag_2: 'Web Development',
		subtitle_1:
			'Lorem ipsum dolor sit amet consectetur. Sem cursus cursus ultrices egestas. Sed proin laoreet id tincidunt egestas.',
		subtitle_2:
			'Lorem ipsum dolor sit amet consectetur. Sem cursus cursus ultrices egestas. Sed proin laoreet id tincidunt egestas. Scelerisque enim velit elementum ac vel fames id. Commodo facilisis proin eu molestie nulla imperdiet viverra porttitor faucibus',
		button_text: 'View More',
		imgSrc: 'assets/homePage/caseStudy-1.PNG',
		imgAlt: 'project-1',
	},
	{
		id: '02',
		title: 'Case Study Name',
		tag_1: 'Web Design',
		tag_2: 'Web Development',
		subtitle_1:
			'Lorem ipsum dolor sit amet consectetur. Sem cursus cursus ultrices egestas. Sed proin laoreet id tincidunt egestas.',
		subtitle_2:
			'Lorem ipsum dolor sit amet consectetur. Sem cursus cursus ultrices egestas. Sed proin laoreet id tincidunt egestas. Scelerisque enim velit elementum ac vel fames id. Commodo facilisis proin eu molestie nulla imperdiet viverra porttitor faucibus',
		button_text: 'View More',
		imgSrc: 'assets/homePage/caseStudy-2.PNG',
		imgAlt: 'project-2',
	},
]
